// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2XfWS","footer":"ModalInfo_footer__1sty7"};